<template>
<div>
    <!-- TOAST PARA LOS MENSAJES -->
    <div class="p-d-flex">
        <Toast />
    </div>
    <!-- CONFIGURACION -->
    <Dialog :showHeader="false" position="top" :visible.sync="dialogConfig" :closeOnEscape="true"
    :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
        <config-mil @closeDialogConfig="dialogConfig = false"></config-mil>
    </Dialog>

    <Dialog :showHeader="false" position="top" :visible.sync="dialogDetalles" :closeOnEscape="true"
    :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
        <detallesMil @closeDialogDetalles="dialogDetalles = false"></detallesMil>
    </Dialog>

    <!-- LOADING -->


    <div class="card">
        <div class="flex justify-content-center flex-wrap card-container">
            <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                <span class="p-float-label">
                    <Calendar v-model="fechaI" dateFormat="dd-MM-yy" @date-select="UltimoDiaMes"/>
                    <label>Fecha Inicial</label>
                  </span>
            </div>
            <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                <span class="p-float-label">
                    <Calendar v-model="fechaF" dateFormat="dd-MM-yy" />
                    <label>Fecha Final</label>
                  </span>
            </div>
            <div class="flex align-items-center justify-content-center w-2rem h-4rem m-2">
                <div class="field col-4">
                    <Button icon="mdi mdi-text-box-search-outline" class="p-button-text p-button-rounded" @click="GetReporte()" v-tooltip.bottom="'Consultar'" style="color:#FBC31F"/>
                </div>
            </div>
            <div class="flex align-items-center justify-content-center w-2rem h-4rem m-2">
                <div class="field col-4">
                    <Button icon="mdi mdi-cog" class="p-button-text p-button-rounded" @click="OpenConfigMil()" v-tooltip.bottom="'Configuración'" style="color:#949695"/>
                </div>
            </div>
        </div>

        <div>
            <DataTable :value="itesmReporte" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown":rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" :loading="loading" :filters.sync="filtros">
                <template #header>
                    <div class="flex justify-content-center flex-wrap card-container">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtros['global'].value" placeholder="Buscar" />
                        </span>
                    </div>
                </template>
                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button v-if="slotProps.data.tipo === 'R'" icon="mdi mdi-format-list-bulleted" class="p-button-text p-button-rounded" v-tooltip.bottom="'Detalles'" @click="OpenDialogDetalles(slotProps.data)" />
                    </template>
                </Column>
                <Column field="cuenta" header="Cuenta" :styles="{'width':'50rem', 'min-width':'20rem'}">
                </Column>
                <Column field="importe" sortable header="Importe" :styles="{'flex-grow':'30', 'flex-basis':'30px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.importe) }}</span>
                      </template>
                </Column>
            </DataTable>
        </div>
    </div>
</div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import configMil from './ReporteMilConfig.vue'
    import detallesMil  from './ReporteMilDetalles.vue'
    import { FilterMatchMode, FilterOperator } from "primevue/api/"

    export default {
        components: {
            configMil,
            detallesMil,
        },
        data() {
            return {
                fechaI: new Date(),
                fechaF: new Date(),
                dialogConfig: false,
                itesmReporte: [],
                loading: false,
                filtros: {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                },
                dialogDetalles: false,
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
        },
        created() {

        },
        methods: {
            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            formtaDate(value){
                return moment(value).format('DD-MM-YYYY')
            },

            OpenConfigMil(){
                this.dialogConfig = true;
            },

            async GetReporte(){
                try{
                    this.loading = true;
                    let fechaI = moment(this.fechaI).format('YYYY-MM-DD')
                    let fechaF = moment(this.fechaF).format('YYYY-MM-DD')
                    let response = await axios.get('ReporteNominas/GetReporteMil/' + this.token.empresaBase + '/' + fechaI + '/' + fechaF);
                    let x = response.data;
                    this.itesmReporte = [ ...x ]
                    console.log(response.data);
                    this.loading = false;
                }catch(error){
                    console.log(error);
                    this.loading = false;
                }
            },
        
            OpenDialogDetalles(item){
                console.log(item)
                let ObjDetalles = {
                    detalles: item.detalle,
                    titulo: item.cuenta
                }
                this.$store.state.reporteMilDet = { ...ObjDetalles };
                this.dialogDetalles = true;
            },

            UltimoDiaMes(){
                let fechaI = this.fechaI;
                let mes = fechaI.getMonth();
                let año = fechaI.getFullYear();
                let fechaF = new Date(año, mes + 1, 0);
                this.fechaF = fechaF;
            },
        
        },
    }
</script>